// ── Shared time/timezone helpers ──────────────────────────────────────────
// Extracted from ScheduleClasses.js (previously private to that file) so
// availabilityHelper.js and the new teacher-availability UI can reuse them
// instead of duplicating timezone math. class_date/start_time across this
// app are always stored as IST wall-clock — ADMIN_TZ is that canonical zone.

export const ADMIN_TZ = 'Asia/Kolkata'

export const TIMEZONES = [
  { value: 'Asia/Kolkata',        label: '🇮🇳 India (IST)         UTC+5:30' },
  { value: 'Europe/London',       label: '🇬🇧 UK (GMT/BST)        UTC+0/+1' },
  { value: 'America/New_York',    label: '🇺🇸 New York (EST/EDT)  UTC-5/-4' },
  { value: 'America/Los_Angeles', label: '🇺🇸 Los Angeles (PST)   UTC-8/-7' },
  { value: 'America/Chicago',     label: '🇺🇸 Chicago (CST)       UTC-6/-5' },
  { value: 'Europe/Paris',        label: '🇫🇷 France (CET)        UTC+1/+2' },
  { value: 'Europe/Berlin',       label: '🇩🇪 Germany (CET)       UTC+1/+2' },
  { value: 'Asia/Dubai',          label: '🇦🇪 Dubai (GST)         UTC+4'    },
  { value: 'Asia/Singapore',      label: '🇸🇬 Singapore (SGT)     UTC+8'    },
  { value: 'Asia/Tokyo',          label: '🇯🇵 Japan (JST)         UTC+9'    },
  { value: 'Australia/Sydney',    label: '🇦🇺 Sydney (AEST)       UTC+10/+11'},
  { value: 'America/Toronto',     label: '🇨🇦 Toronto (EST)       UTC-5/-4' },
  { value: 'Asia/Riyadh',         label: '🇸🇦 Saudi Arabia (AST)  UTC+3'    },
  { value: 'Africa/Johannesburg', label: '🇿🇦 South Africa (SAST) UTC+2'    },
  { value: 'UTC',                 label: '🌐 UTC                  UTC+0'    },
]

export function convertTime(date, time, fromTZ, toTZ) {
  if (!time || !date || fromTZ === toTZ) return time
  try {
    const localStr   = `${date}T${time}:00`
    const tempDate   = new Date(localStr)
    const fromOffset = new Date(tempDate.toLocaleString('en-US', { timeZone: fromTZ })) - tempDate
    const toOffset   = new Date(tempDate.toLocaleString('en-US', { timeZone: toTZ   })) - tempDate
    const converted  = new Date(tempDate.getTime() + (fromOffset - toOffset))
    return converted.toTimeString().slice(0, 5)
  } catch(e) { return time }
}

export function fmtTime(t) {
  if (!t) return '—'
  return new Date('2000-01-01T' + t).toLocaleTimeString('en-IN', { hour:'2-digit', minute:'2-digit', hour12:true })
}

export function nowInTZ(tz) {
  return new Date().toLocaleString('en-US', { timeZone: tz, hour:'2-digit', minute:'2-digit', hour12:false }).slice(0,5)
}

// ── New helpers for teacher-availability math ─────────────────────────────

// IST wall-clock day-of-week for a class_date string — matches the pattern
// already proven safe in ScheduleClasses.js's generateDates() and
// BulkReschedule.js's shiftToWeekday(): class_date is already an IST
// calendar date, so parsing at local midnight (no explicit offset) is
// correct and avoids UTC-boundary off-by-one bugs.
export function dayOfWeekIST(dateStr) {
  return new Date(dateStr + 'T00:00:00').getDay()
}

export function toMinutes(hhmm) {
  const [h, m] = (hhmm || '00:00').slice(0, 5).split(':').map(Number)
  return (h || 0) * 60 + (m || 0)
}

export function minutesToHHMM(min) {
  const h = Math.floor(min / 60), m = min % 60
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
}

export const DAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
